/* ENGRAM · The Memory Club · «Qual é o seu número?» (ecrãs 6e, 6f) — sections/engram-club-number.
   Aritmética no navegador, sem servidor. Os limites e os contadores vêm do Liquid (snippets/engram-key-config) nos
   data-* do bloco; os textos vêm dos locales, já escritos na página. Regras (docs/MEMORY_CLUB.md §5.1):
   1 a founders-total = Fundadores (gravado se ≤ founders-used); daí até first-to = First Chapter, até inner-to =
   Inner Circle, depois Memory Keepers (gravado se ≤ last-key). Um número por gravar dá «Ainda não gravámos». */
(() => {
  const format = (n, template) => {
    if (n < 1000) return String(n);
    const rest = String((n % 1000) + 1000).slice(1);
    return template.replace('__T__', String(Math.floor(n / 1000))).replace('__R__', rest);
  };

  document.querySelectorAll('[data-engram-club-number]').forEach((box) => {
    const num = (key) => parseInt(box.dataset[key], 10) || 0;
    const foundersTotal = num('foundersTotal');
    const foundersUsed = num('foundersUsed');
    const firstTo = num('firstTo');
    const innerTo = num('innerTo');
    const lastKey = num('lastKey');
    const thousands = box.dataset.thousands || '__T__ __R__';

    const form = box.querySelector('form');
    const input = box.querySelector('input');
    const error = box.querySelector('.engram-club-number__error');
    const result = box.querySelector('.engram-club-number__result');
    const cards = result ? result.querySelectorAll('.engram-club-level') : [];
    if (!form || !input || !error || !result) return;

    // guarda a linha de cima de cada cartão com o marcador do número, para a poder repetir
    cards.forEach((card) => {
      const top = card.querySelector('.engram-club-level__range');
      if (top) top.dataset.template = top.textContent;
    });

    const levelOf = (n) => {
      if (n <= foundersTotal) return n <= foundersUsed ? 'founding_thirty' : null;
      if (n > lastKey) return null;
      if (n <= firstTo) return 'first_chapter';
      if (n <= innerTo) return 'inner_circle';
      return 'memory_keepers';
    };

    const reset = () => {
      error.hidden = true;
      error.textContent = '';
      input.removeAttribute('aria-invalid');
      result.classList.remove('is-shown');
      cards.forEach((card) => { card.hidden = true; });
    };

    /* o texto vem de um atributo data-*; nas línguas traduzidas pode chegar com entidades HTML («&#39;»): descodifica-se (QA, 28 Out) */
    const decode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };
    const fail = (message) => {
      error.textContent = decode(message);
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    };

    reset();
    input.addEventListener('input', () => { if (!error.hidden) reset(); });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      reset();
      const raw = input.value.replace(/[\s.,]/g, '');
      if (!/^\d+$/.test(raw) || parseInt(raw, 10) < 1) {
        fail(error.dataset.invalid);
        return;
      }
      const n = parseInt(raw, 10);
      const level = levelOf(n);
      if (!level) {
        fail(error.dataset.notFound);
        return;
      }
      cards.forEach((card) => {
        const match = card.dataset.level === level;
        card.hidden = !match;
        const top = card.querySelector('.engram-club-level__range');
        if (match && top) top.textContent = top.dataset.template.replace('__N__', format(n, thousands));
      });
      result.classList.add('is-shown');
    });
  });
})();
